<template>
  <section class="landscape">
    <div class="landscape__box">
      <img src="data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'%3E%3Cg fill='%23fff'%3E%3Cpath d='M97.4 82.909a11.48 11.48 0 0 1-10.815 11.444l2.138 2.127a1.633 1.633 0 0 1 0 2.313v.005a1.641 1.641 0 0 1-2.318-.01l-4.918-4.909a1.635 1.635 0 0 1-.356-1.779 1.661 1.661 0 0 1 .328-.481c.013-.014.018-.034.033-.049l4.917-4.909a1.642 1.642 0 0 1 2.278 0 1.634 1.634 0 0 1 .04 2.314l-2.041 2.04a8.17 8.17 0 0 0 7.439-8.105v-.273a1.637 1.637 0 0 1 1.639-1.636 1.638 1.638 0 0 1 1.64 1.636zM77.7 18.456a1.625 1.625 0 0 1-1.629 1.621 1.625 1.625 0 0 1-1.629-1.621V5.496a1.625 1.625 0 0 0-1.629-1.621H61.758l-1.67 3.879a1.632 1.632 0 0 1-1.5.982H41.41a1.631 1.631 0 0 1-1.5-.982l-1.671-3.879H27.2a1.625 1.625 0 0 0-1.629 1.621v12.96a1.625 1.625 0 0 1-1.629 1.621 1.625 1.625 0 0 1-1.629-1.621V5.496A4.874 4.874 0 0 1 27.2.635h45.6a4.874 4.874 0 0 1 4.887 4.861zM42.492 5.496h15.025l.7-1.621H41.786zM77.7 95.14a4.873 4.873 0 0 1-4.887 4.86H27.2a4.873 4.873 0 0 1-4.887-4.86V82.179a1.625 1.625 0 0 1 1.629-1.62 1.625 1.625 0 0 1 1.629 1.62V95.14a1.624 1.624 0 0 0 1.629 1.62h45.6a1.624 1.624 0 0 0 1.629-1.62V82.179a1.625 1.625 0 0 1 1.629-1.62 1.625 1.625 0 0 1 1.629 1.62zm-9-48.639l-4.91 4.918a1.584 1.584 0 0 1-.491.328 1.536 1.536 0 0 1-.163.061 1.583 1.583 0 0 1-.4.077c-.036 0-.085.021-.106.021s-.041-.012-.062-.012a1.623 1.623 0 0 1-.515-.1.064.064 0 0 0-.043-.011 1.619 1.619 0 0 1-.481-.328c-.014-.012-.034-.018-.049-.032l-4.909-4.918a1.64 1.64 0 0 1 0-2.277 1.634 1.634 0 0 1 2.314-.042l.842.844a11.483 11.483 0 0 0-5.931-5.414A11.467 11.467 0 0 0 38.873 46a11.5 11.5 0 0 0 6.373 14.948 11.466 11.466 0 0 0 14.923-6.383l.039-.1a1.636 1.636 0 0 1 2.157-.837 1.64 1.64 0 0 1 .836 2.161 14.738 14.738 0 0 1-10.136 8.784A14.726 14.726 0 0 1 35.25 53.764a14.753 14.753 0 0 1 10.785-17.842 14.724 14.724 0 0 1 17.814 10.809l2.542-2.548h-.012a1.635 1.635 0 0 1 2.274 0 1.637 1.637 0 0 1 .5 1.179 1.634 1.634 0 0 1-.459 1.139zM18.557 7.172a1.657 1.657 0 0 1-.329.481c-.014.014-.018.034-.032.049l-4.918 4.909a1.641 1.641 0 0 1-2.278 0 1.634 1.634 0 0 1-.04-2.314l2.042-2.04a8.171 8.171 0 0 0-7.44 8.105v1.273a1.638 1.638 0 0 1-1.639 1.637 1.639 1.639 0 0 1-1.64-1.637v-1.273a11.481 11.481 0 0 1 10.81-11.44l-2.138-2.127a1.634 1.634 0 0 1 0-2.314 1.642 1.642 0 0 1 2.318.009l4.918 4.909a1.636 1.636 0 0 1 .479 1.157 1.635 1.635 0 0 1-.119.615z'/%3E%3Cpath d='M0 27.825v45a4.861 4.861 0 0 0 4.9 4.821h90.2a4.861 4.861 0 0 0 4.9-4.826v-45a4.861 4.861 0 0 0-4.9-4.821H4.9A4.861 4.861 0 0 0 0 27.825zm3.267 14.4l1.633.688v14.818l-1.633.688zM95.1 26.216a1.621 1.621 0 0 1 1.633 1.609v45a1.621 1.621 0 0 1-1.633 1.6H4.9a1.62 1.62 0 0 1-1.633-1.607v-10.9l3.91-1.648a1.607 1.607 0 0 0 .99-1.477v-16.94a1.606 1.606 0 0 0-.99-1.477l-3.91-1.649V27.825A1.62 1.62 0 0 1 4.9 26.218z' opacity='.5'/%3E%3C/g%3E%3C/svg%3E">
      <p class="landscape__tip">旋转屏幕</p>
    </div>
  </section>
</template>

<script>
export default {
  components: {
  },
  data(){
    return {
      rightOrientation:true
    }
  },
  methods: {
    onScreenRotate() {
      if (window.orientation === 180 || window.orientation === 0) {   // 竖屏
        this.$emit('landscape-hide');
        if(!this.rightOrientation){
          location.reload(true);
        }
        return;
      }
      if (window.orientation === 90 || window.orientation === -90) {    // 横屏
        this.$emit('landscape-show');
        return;
      }
      if (window.innerWidth > window.innerHeight) {
        this.$emit('landscape-show');
        return;
      }
      if(!this.rightOrientation){
        location.reload(true);
      }
      this.$emit('landscape-hide');
    },
    listenScreenRotate() {
      let supportRotationChange = 'onorientationchange' in window;

      window.addEventListener(supportRotationChange ? 'orientationchange' : 'resize', () => {
        this.onScreenRotate();
      });
    },
  },
  created() {
    if((window.orientation === 90 || window.orientation === -90)||(window.innerWidth > window.innerHeight)){
      this.rightOrientation = false
    }
    this.onScreenRotate();
    this.listenScreenRotate();
  },
}
</script>

<style lang="scss" scoped>
.landscape{
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: #333;
  overflow: hidden;
  z-index: 2;
  transform: translateZ(120px);
  &__box{
    @include abs_both_middle();
    text-align: center;
  }
  &__logo{
    width: 100px;
    vertical-align: top;
  }
  &__tip{
    font-size: 16px;
    line-height: 1.3;
    font-weight: 600;
    color: #FFF;
    margin: 20px 0 0;
    white-space: nowrap;
  }
}
</style>
